import React from "react";

export default function Analytics() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Platform Analytics</h2>
      <p className="text-muted-foreground">Analytics dashboard coming soon...</p>
    </div>
  );
}
